:host {
  width: 100%;
}

.stzh-vbz-connection-finder {
  @include spaceCurve('padding-top', 'medium');
  @include spaceCurve('padding-bottom', 'medium');
}


